import { forwardRef } from 'react';
import { View } from 'react-native';
import { InfoText } from '../InfoText';
import { TextFieldRef } from '../Text/TextField';
import { AmountEntryField } from './AmountEntryField';
import { AssetFieldProps } from './AssetField.types';
import { AssetFieldSelector } from './AssetFieldSelector';

const AssetField = forwardRef<TextFieldRef, AssetFieldProps>(
  (
    {
      tag,
      placeholder,
      stateSelector,
      hasError = false,
      onPress,
      iconProps,
      maxLength,
      onPlusPressed,
      onMinusPressed,
      autoFocus,
      onValueChanged,
      value,
      className,
      selectorClassName,
      currencyIcon,
      infoText,
      backgroundColor,
      showPlusMinusButtons,
      assetCode,
      percentageButtons,
      onPercentageButtonPressed,
      onFocus,
      onBlur,
      readonly = false,
      selectable = true,
    },
    ref
  ) => {
    return (
      <View className={className}>
        <View className="flex flex-row w-full">
          <AssetFieldSelector
            className={selectorClassName}
            iconProps={iconProps}
            selectedAssetCode={assetCode}
            tag={tag}
            placeholder={placeholder}
            state={stateSelector}
            position={'left'}
            onPress={onPress}
            iconComponent={currencyIcon}
            backgroundColor={backgroundColor}
            disabled={!selectable}
            showDropdownIcon={selectable}
          />
          <AmountEntryField
            ref={ref}
            maxLength={maxLength}
            className="flex-1"
            hasError={hasError}
            value={value}
            onValueChanged={onValueChanged}
            onPlusPressed={onPlusPressed}
            onMinusPressed={onMinusPressed}
            autoFocus={autoFocus}
            readonly={readonly}
            showPlusMinusButtons={showPlusMinusButtons}
            assetCode={assetCode}
            percentageButtons={percentageButtons}
            onPercentageButtonPressed={onPercentageButtonPressed}
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </View>

        {infoText && (
          <InfoText
            infoText={infoText}
            hasError={hasError}
            inputClass="items-end mt-3"
          />
        )}
      </View>
    );
  }
);

export default AssetField;
